module.exports = __webpack_public_path__ + "fonts/Chap-Light.6bed089f.otf";